import { Avatar, AvatarGroup, Tooltip } from "@mui/material";
import { getAvatarColor } from "utils/taskUtils";

/** Compact stack of avatars for a task's owner + collaborators, with name tooltips. */
const TaskAssigneeAvatars = ({ people = [], max = 4, size = 26 }) => {
  const visible = (people || []).filter(Boolean);
  if (visible.length === 0) {
    return (
      <Avatar sx={{ width: size, height: size, fontSize: size * 0.45, bgcolor: "grey.400" }}>
        ?
      </Avatar>
    );
  }

  return (
    <AvatarGroup
      max={max}
      sx={{
        "& .MuiAvatar-root": {
          width: size,
          height: size,
          fontSize: size * 0.45,
          border: "2px solid var(--app-surface, #fff)",
        },
      }}
    >
      {visible.map((person, idx) => (
        <Tooltip key={person.id ?? person.email ?? idx} title={person.name || "Unknown"}>
          <Avatar sx={{ bgcolor: getAvatarColor(person.id ?? person.name) }}>
            {(person.name || "?").charAt(0).toUpperCase()}
          </Avatar>
        </Tooltip>
      ))}
    </AvatarGroup>
  );
};

export default TaskAssigneeAvatars;
